// Permissions catalog aligned with API

export const ALL_PERMISSIONS = [
  { id: 1, name: "user.view" },
  { id: 2, name: "user.create" },
  { id: 3, name: "user.update" },
  { id: 4, name: "user.delete" },
  { id: 5, name: "role.view" },
  { id: 6, name: "role.create" },
  { id: 7, name: "role.update" },
  { id: 8, name: "role.delete" },
  { id: 9, name: "permission.view" },
  { id: 10, name: "permission.create" },
  { id: 11, name: "permission.update" },
  { id: 12, name: "permission.delete" },
  { id: 13, name: "categories.view" },
  { id: 14, name: "categories.create" },
  { id: 15, name: "categories.update" },
  { id: 16, name: "categories.delete" },
  { id: 17, name: "tags.view" },
  { id: 18, name: "tags.create" },
  { id: 19, name: "tags.update" },
  { id: 20, name: "tags.delete" },
  { id: 21, name: "settings.view" },
  { id: 22, name: "settings.create" },
  { id: 23, name: "settings.update" },
  { id: 24, name: "settings.delete" },
  { id: 25, name: "branch.view" },
  { id: 26, name: "branch.create" },
  { id: 27, name: "branch.update" },
  { id: 28, name: "branch.delete" },
  { id: 29, name: "items.view" },
  { id: 30, name: "items.create" },
  { id: 31, name: "items.update" },
  { id: 32, name: "items.delete" },
  { id: 33, name: "supplier.view" },
  { id: 34, name: "supplier.create" },
  { id: 35, name: "supplier.update" },
  { id: 36, name: "supplier.delete" },
  { id: 37, name: "po.view" },
  { id: 38, name: "po.create" },
  { id: 39, name: "po.update" },
  { id: 40, name: "po.delete" },
  { id: 41, name: "po.confirm" },
  { id: 42, name: "variants.view" },
  { id: 43, name: "variants.create" },
  { id: 44, name: "variants.update" },
  { id: 45, name: "variants.delete" },
  { id: 46, name: "batch.view" },
  { id: 47, name: "batch.create" },
  { id: 48, name: "batch.update" },
  { id: 49, name: "batch.delete" },
  { id: 50, name: "inventory.view" },
  { id: 51, name: "inventory.create" },
  { id: 52, name: "openingBalance.view" },
  { id: 53, name: "openingBalance.create" },
  { id: 54, name: "openingBalance.update" },
  { id: 55, name: "openingBalance.delete" },
  { id: 56, name: "transfer.view" },
  { id: 57, name: "transfer.create" },
  { id: 58, name: "transfer.update" },
  { id: 59, name: "transfer.delete" },
  { id: 60, name: "transfer.confirm" },
  { id: 61, name: "transfer.viewIncoming" },
  { id: 62, name: "transfer.viewOutgoing" },
  // CK Prepared Item Requests
  { id: 66, name: "ckRequestPreparedItem.view" },
  { id: 67, name: "ckRequestPreparedItem.confirmQty" },
  { id: 68, name: "ckRequestPreparedItem.update" },
  { id: 69, name: "ckRequestPreparedItem.sendItem" },
  { id: 63, name: "branchRequestPreparedItem.view" },
  { id: 64, name: "branchRequestPreparedItem.create" },
  { id: 65, name: "branchRequestPreparedItem.update" },
] as const;

export type PermissionName = (typeof ALL_PERMISSIONS)[number]["name"];
export type PermissionId = (typeof ALL_PERMISSIONS)[number]["id"];
